<script>
  import {onMount, onDestroy, tick} from "svelte"
  import { derived } from "svelte/store"
  import DialogTitle from "../../../../components/dialog/DialogTitle.svelte";
  import DialogContent from "../../../../components/dialog/DialogContent.svelte";
  import DialogBottomControls from "../../../../components/dialog/DialogBottomControls.svelte";
  import DialogBottomControlButton from "../../../../components/dialog/DialogBottomControlButton.svelte";
  import DialogSplitter from "../../../../components/dialog/DialogSplitter.svelte";
  import SectionTitle from "../../../../components/layout/SectionTitle.svelte";
  import { useInvalidateLicenseData, useLicenseDataQuery } from "../../../../hooks/license/useLicenseData.js";
  import Loading from "../../../../components/pages/Loading.svelte";
  import PrimaryBorderedButton from "../../../../components/button/generic/PrimaryBorderedButton.svelte";
  import ChangeLicenseAuthenticationMethodDialog
    from "../ChangeLicenseAuthenticationMethodDialog/ChangeLicenseAuthenticationMethodDialog.svelte";
  import EProtector from "./AuthMethod/EProtector.svelte";
  import OnlineLicense from "./AuthMethod/OnlineLicense.svelte";
  import Alert from "../../../../components/Alerts/Alert.svelte";
  import { translate } from "../../../../i18n/i18next.js";
  import DialogBase2 from "../../../../components/dialog/DialogBase2.svelte";

  export let onClose

  const {invalidateLicenseData} = useInvalidateLicenseData()
  async function handleClose() {
    await invalidateLicenseData()
    onClose()
  }

  const licenseDataQuery = useLicenseDataQuery()
  const currentAuthMethod = derived(licenseDataQuery, query => query.data?.authMethod ?? null)

  let isChangeLicenseAuthenticationMethodDialogOpen = false

  let dialog
  onMount(async () => {
    await tick()
    dialog.showModal()
  })
  onDestroy(() => {
    dialog.close()
  })
</script>

<DialogBase2 bind:dialog={dialog} onClose={onClose} width="800px">
  <DialogTitle title={translate("frontend:components.manageLicenseAuthenticationDialog.title")} />
  <DialogSplitter />
  {#if $licenseDataQuery.isLoading}
    <Loading height="15vh" />
  {/if}
  {#if $licenseDataQuery.isError}
    <div>
      <Alert type="error">{translate("frontend:components.manageLicenseAuthenticationDialog.messages.failedToRetrieveLicenseData")}</Alert>
    </div>
  {/if}
  {#if $licenseDataQuery.isSuccess}
    <DialogContent>
      {#if $currentAuthMethod !== "none"}
        <SectionTitle>
          <div style="display: inline-flex; gap: 1rem; flex-wrap: wrap">
            <span>{translate("frontend:components.manageLicenseAuthenticationDialog.currentAuthenticationMethod.title")}:
              {#if $currentAuthMethod === "eProtector"}
                {translate("generic.license.protectors.eProtector")}
              {/if}
              {#if $currentAuthMethod === "invalidEProtector"}
                {translate("generic.license.protectors.eProtector")} ({translate("generic.invalid")})
              {/if}
              {#if $currentAuthMethod === "online"}
                {translate("generic.license.protectors.online")}
              {/if}
              {#if $currentAuthMethod === "none"}
                {translate("generic.license.protectors.none")}
              {/if}
              {#if $currentAuthMethod === "dev"}
                dev
              {/if}
            </span>
            <PrimaryBorderedButton onClick={() => isChangeLicenseAuthenticationMethodDialogOpen = true}>
              {#if $currentAuthMethod === "none"}
                {translate("generic.authenticate")}
              {:else}
                {translate("generic.change")}
              {/if}
            </PrimaryBorderedButton>
          </div>
        </SectionTitle>
        <DialogSplitter/>
      {/if}
      {#if $currentAuthMethod === "eProtector" || $currentAuthMethod === "invalidEProtector"}
        <EProtector/>
      {/if}
      {#if $currentAuthMethod === "online" || $currentAuthMethod === "invalidOnlineLicense"}
        <OnlineLicense closeDialog={handleClose} />
      {/if}
    </DialogContent>
  {/if}
  <DialogSplitter />
  <DialogBottomControls>
    <DialogBottomControlButton type="primary" onClick={handleClose}>
      OK
    </DialogBottomControlButton>
  </DialogBottomControls>
</DialogBase2>
{#if isChangeLicenseAuthenticationMethodDialogOpen}
  <ChangeLicenseAuthenticationMethodDialog
    onClose={() => isChangeLicenseAuthenticationMethodDialogOpen = false}
  />
{/if}
